import { DEV_BO_API } from 'src/config-global';

export const endpoints = {
  inviteUser: `${DEV_BO_API}api/users/invite`,
  registerUser: `${DEV_BO_API}api/users/register`,
  forgotPassword: `${DEV_BO_API}api/users/forgotPassword`,
  resetPassword: `${DEV_BO_API}api/users/resetPassword`,
  changePassword: `${DEV_BO_API}api/users/changePassword`,
  mfaEnable: `${DEV_BO_API}api/mfa/enable`,
  mfaVerify: `${DEV_BO_API}api/mfa/verify`,
  mfaRequestReset: `${DEV_BO_API}api/mfa/requestReset`,
  mfaReset: `${DEV_BO_API}api/mfa/reset`,
  mfaConfirmReset: `${DEV_BO_API}api/mfa/confirmReset`,
  getUserById: `${DEV_BO_API}api/users/:userId`,
  deleteUser: `${DEV_BO_API}api/users/:userId`,
  editUser: `${DEV_BO_API}api/users/:userId`,
  reactivateUser: `${DEV_BO_API}api/users/:userId/reactivate`,
  getAllAttributes: `${DEV_BO_API}api/attributes?attributeTypes=1,2,3,4,5,6,7,8,9,10,11,12,13`,
  getAllUsers: `${DEV_BO_API}api/users`,
  getAllRoles: `${DEV_BO_API}api/roles`,
  getCurrentUser: `${DEV_BO_API}api/users/me`,
  apiDocs: `${DEV_BO_API}api/docs`,
  addProducer: `${DEV_BO_API}api/producers`,
  getProducers: `${DEV_BO_API}api/producers`,
  getProducerById: `${DEV_BO_API}api/producers/:producerId`,
  editProducer: `${DEV_BO_API}api/producers/:producerId`,
  uploadFile: `${DEV_BO_API}api/file-upload`,
  searchProducts: `${DEV_BO_API}api/products/search`,
  searchProductsByDistributor: `${DEV_BO_API}api/distributors/:orgId/products/search`,
  addProductSeason: `${DEV_BO_API}api/distributors/:distributorOrgId/sites/:distributorSiteId/seasons`,
  editProductSeason: `${DEV_BO_API}api/distributors/:distributorOrgId/sites/:distributorSiteId/seasons/:seasonId`,
  searchProductSeasons: `${DEV_BO_API}api/distributors/:distributorOrgId/sites/:distributorSiteId/product-seasons/search`,
  getProductSeasonDetails: `${DEV_BO_API}api/distributors/:distributorOrgId/sites/:distributorSiteId/seasons/:seasonId`,
  deleteProductSeason: `${DEV_BO_API}api/distributors/:distributorOrgId/sites/:distributorSiteId/seasons/:seasonId`,
  getSeasonalCalendarEntriesDistributor: `${DEV_BO_API}api/distributors/:distributorOrgId/sites/:distributorSiteId/season-calendar/search`,
  addProductDraft: `${DEV_BO_API}api/product-drafts`,
  updateProductDraft: `${DEV_BO_API}api/product-drafts/:draftId`,
  deleteProductDraft: `${DEV_BO_API}api/product-drafts/:draftId`,
  updateProductTemplate: `${DEV_BO_API}api/products/:productId`,
  getProductDrafts: `${DEV_BO_API}api/product-drafts`,
  getProductDraftById: `${DEV_BO_API}api/product-drafts/:draftId`,
  getProductById: `${DEV_BO_API}api/products/:productId`,
  getProductInfoById: `${DEV_BO_API}api/products/:productId/information`,
  getProductComponents: `${DEV_BO_API}api/products/components/bulk-read`,
  updateProductComponents: `${DEV_BO_API}api/products/components/bulk-update-provenance`,
  addProduct: `${DEV_BO_API}api/distributors/:distributorOrgId/products`,
  queueProductCategoryAssignment: `${DEV_BO_API}api/products/:productId/queue-category-assignment`,
  setProductArchived: `${DEV_BO_API}api/products/:productId/archive`,
  addDistributorOrg: `${DEV_BO_API}api/distributors`,
  editDistributorOrg: `${DEV_BO_API}api/distributors/:distributorOrgId`,
  addDistributorSite: `${DEV_BO_API}api/distributors/:distributorOrgId/sites`,
  editDistributorSite: `${DEV_BO_API}api/distributors/:distributorOrgId/sites/:distributorSiteId`,
  getAllDistributorOrgs: `${DEV_BO_API}api/distributors`,
  getDistributorOrgById: `${DEV_BO_API}api/distributors/:distributorOrgId`,
  getProductTemplatesByDistributorId: `${DEV_BO_API}api/products/export/:distributorOrgId`,
  getProductBespokePricesByDistributorId: `${DEV_BO_API}api/products/prices/custom/export/:distributorOrgId`,
  bulkUploadTemplates: `${DEV_BO_API}api/distributors/:distributorOrgId/products/bulkImport`,
  getProductPricesDistributorId: `${DEV_BO_API}api/products/prices/export/:distributorOrgId`,
  bulkUploadProductPrices: `${DEV_BO_API}api/distributors/:distributorOrgId/products/prices/bulkImport`,
  bulkUploadBespokePrices: `${DEV_BO_API}api/distributors/:distributorOrgId/products/prices/bulkImportBespoke`,
  getCsvImports: `${DEV_BO_API}api/distributors/:distributorId/products/csvImports`,
  getCsvImportById: `${DEV_BO_API}api/distributors/:distributorId/products/csvImports/:csvImportId`,
  exportProductTemplateCsvErrors: `${DEV_BO_API}api/distributors/:orgId/products/csvImports/:csvId/exportErrors`,
  getPriceCsvImports: `${DEV_BO_API}api/distributors/:distributorId/products/prices/csvImports`,
  getPriceCsvImportById: `${DEV_BO_API}api/distributors/:distributorId/products/prices/csvImports/:csvImportId`,
  getBespokePriceCsvImports: `${DEV_BO_API}api/distributors/:distributorId/products/prices/bespoke/csvImports`,
  getBespokePriceCsvImportById: `${DEV_BO_API}api/distributors/:distributorId/products/prices/bespoke/csvImports/:csvImportId`,
  getDistributorSiteById: `${DEV_BO_API}api/distributors/:distributorOrgId/sites/:distributorSiteId`,
  getDistributorSitesByDistributorId: `${DEV_BO_API}api/distributors/:distributorOrgId/sites`,
  getDistributorSiteFfcs: `${DEV_BO_API}api/distributors/:orgId/sites/:siteId/ffcs`,
  getDistributorSiteFfcById: `${DEV_BO_API}api/distributors/:orgId/sites/:siteId/ffcs/:ffcId`,
  createDistributorSiteFfc: `${DEV_BO_API}api/distributors/:orgId/sites/:siteId/ffcs`,
  updateDistributorSiteFfc: `${DEV_BO_API}api/distributors/:orgId/sites/:siteId/ffcs/:ffcId`,
  deleteDistributorSiteFfc: `${DEV_BO_API}api/distributors/:orgId/sites/:siteId/ffcs/:ffcId`,
  createDistributorSiteFfcSlot: `${DEV_BO_API}api/distributors/:orgId/sites/:siteId/ffcs/:ffcId/slots`,
  updateDistributorSiteFfcSlot: `${DEV_BO_API}api/distributors/:orgId/sites/:siteId/ffcs/:ffcId/slots/:slotId`,
  deleteDistributorSiteFfcSlot: `${DEV_BO_API}api/distributors/:orgId/sites/:siteId/ffcs/:ffcId/slots/:slotId`,
  getAllBuyers: `${DEV_BO_API}api/buyers`,
  addBuyer: `${DEV_BO_API}api/buyers`,
  getBuyerOrgById: `${DEV_BO_API}api/buyers/:buyerOrgId`,
  addBuyerSite: `${DEV_BO_API}api/buyers/:buyerOrgId/sites`,
  editBuyerSite: `${DEV_BO_API}api/buyers/:buyerOrgId/sites/:buyerSiteId`,
  editBuyerOrg: `${DEV_BO_API}api/buyers/:buyerOrgId`,
  getBuyerSite: `${DEV_BO_API}api/buyers/:buyerOrgId/sites/:buyerSiteId`,
  getBuyerSitesForBuyerOrg: `${DEV_BO_API}api/buyers/:buyerOrgId/sites`,
  getLinkedBuyerSitesForDistributor: `${DEV_BO_API}api/distributors/:distributorId/buyers/:buyerId/sites`,
  addLinkBuyerSite: `${DEV_BO_API}api/distributors/:distributorId/sites/:siteId/buyerSites/link`,
  unlinkBuyerSite: `${DEV_BO_API}api/distributors/:distributorId/sites/:siteId/buyerSites/unlink`,
  editLinkBuyerSite: `${DEV_BO_API}api/distributors/:distributorId/sites/:siteId/buyerSites/link`,
  getInvoiceWhitelist: `${DEV_BO_API}api/buyers/:buyerOrgId/invoice-whitelist`,
  addInvoiceWhitelistEntry: `${DEV_BO_API}api/buyers/:buyerOrgId/invoice-whitelist`,
  deleteInvoiceWhitelistEntry: `${DEV_BO_API}api/buyers/:buyerOrgId/invoice-whitelist/:whitelistId`,
  getAttributes: `${DEV_BO_API}api/attributes`,
  getBuyerOrders: `${DEV_BO_API}api/orders`,
  getBuyerOrdersForDistributor: `${DEV_BO_API}api/distributors/:distributorId/orders`,
  getBuyerOrdersForBuyer: `${DEV_BO_API}api/buyers/:buyerId/orders`,
  getBuyerOrderDetailsForBuyer: `${DEV_BO_API}api/buyers/:buyerId/orders/:orderId`,
  downloadBuyerOrderPdfForBuyer: `${DEV_BO_API}api/buyers/:buyerId/orders/:orderId/pdf`,
  getDistributorSitesForBuyerOrg: `${DEV_BO_API}api/buyers/:buyerId/distributor-sites`,
  getLinkedDistributorOrgsForBuyer: `${DEV_BO_API}api/buyers/:buyerId/distributors`,
  getLinkedDistributorSitesForBuyer: `${DEV_BO_API}api/buyers/:buyerId/distributors/:distributorOrgId/sites`,
  getOrdersForDistributorSite: `${DEV_BO_API}api/distributors/:distributorId/sites/:siteId/orders`,
  getOrderForDistributorSite: `${DEV_BO_API}api/distributors/:distributorId/sites/:siteId/orders/:orderId`,
  downloadOrderPdfForDistributorSite: `${DEV_BO_API}api/distributors/:distributorId/sites/:siteId/orders/:orderId/pdf`,
  getOrderIssuesForDistributorSite: `${DEV_BO_API}api/distributors/:distributorId/order-issues`,
  getOrderIssueById: `${DEV_BO_API}api/distributors/:distributorId/order-issues/:issueId`,
  createOrderIssueReply: `${DEV_BO_API}api/distributors/:distributorId/order-issues/:issueId/replies`,
  createOrderIssueReplyByEmail: `${DEV_BO_API}api/order-issue-reply/:emailReplyId/reply`,
  getOrderIssueByEmailId: `${DEV_BO_API}api/order-issue-reply/:emailReplyId`,
  getOrderIssuesForBuyerOrg: `${DEV_BO_API}api/buyers/:buyerOrgId/order-issues`,
  getOrderIssueByIdForBuyerOrg: `${DEV_BO_API}api/buyers/:buyerOrgId/order-issues/:issueId`,
  createBuyerOrgOrderIssueReply: `${DEV_BO_API}api/buyers/:buyerOrgId/order-issues/:issueId/replies`,
  exportPurchaseOrders: `${DEV_BO_API}api/orders/export/po`,
  exportGoodsReceivedNotes: `${DEV_BO_API}api/orders/export/grn`,
  exportCreditNoteRequests: `${DEV_BO_API}api/orders/export/cnr`,
  getAllNewsPosts: `${DEV_BO_API}api/news`,
  newsPostById: `${DEV_BO_API}api/news/:id`,
  manageNewsPosts: `${DEV_BO_API}api/news/manage`,
  manageNewsPostById: `${DEV_BO_API}api/news/manage/:id`,
  createNewsPost: `${DEV_BO_API}api/news/create`,
  getAllMarkers: `${DEV_BO_API}api/markers`,
  createMarker: `${DEV_BO_API}api/markers`,
  editMarker: `${DEV_BO_API}api/markers/:id`,
  deleteMarker: `${DEV_BO_API}api/markers/:id`,
  getAllMarkerForProducer: `${DEV_BO_API}api/producers/:producerId/markers`,
  getAllMeasuringMethods: `${DEV_BO_API}api/measuring-methods`,
  createMeasuringMethod: `${DEV_BO_API}api/measuring-methods`,
  getMeasuringMethodById: `${DEV_BO_API}api/measuring-methods/:id`,
  editMeasuringMethodById: `${DEV_BO_API}api/measuring-methods/:id`,
  deleteMeasuringMethod: `${DEV_BO_API}api/measuring-methods/:id`,
  getAllMeasuringMethodRequests: `${DEV_BO_API}api/measuring-method-requests`,
  createMeasuringMethodRequest: `${DEV_BO_API}api/measuring-method-requests`,
  deleteMeasuringMethodRequest: `${DEV_BO_API}api/measuring-method-requests/:id`,
  getAllSurplus: `${DEV_BO_API}api/distributors/:orgId/sites/:siteId/surplus/surplusEntity`,
  getSurplusById: `${DEV_BO_API}api/distributors/:orgId/sites/:siteId/surplus/surplusEntity/:surplusEntityId`,
  createSurplus: `${DEV_BO_API}api/distributors/:orgId/sites/:siteId/surplus/:productStockId`,
  editSurplus: `${DEV_BO_API}api/distributors/:orgId/sites/:siteId/surplus/surplusEntity/:surplusEntityId`,
  deleteSurplus: `${DEV_BO_API}api/distributors/:orgId/sites/:siteId/surplus/surplusEntity/:surplusEntityId`,
  distributorSearchProducts: `${DEV_BO_API}api/distributors/:orgId/sites/:siteId/products`,
  getProducerProductTemplates: `${DEV_BO_API}api/distributors/:orgId/producer/product-templates`,
  createMeasurementForProducer: `${DEV_BO_API}api/producers/:producerId/measurements`,
  getAllMeasurementsForProducer: `${DEV_BO_API}api/producers/:producerId/measurements`,
  getMeasurementByIdForProducer: `${DEV_BO_API}api/producers/:producerId/measurements/:id`,
  getAllMeasurements: `${DEV_BO_API}api/measurements`,
  getMeasurementById: `${DEV_BO_API}api/measurements/:id`,
  deleteMeasurement: `${DEV_BO_API}api/measurements/:id`,
  resolveMeasurement: `${DEV_BO_API}api/measurements/:id/resolve`,
  uploadInvoices: `${DEV_BO_API}api/invoices/upload`,
  getAllInvoices: `${DEV_BO_API}api/invoices`,
  getPendingInvoices: `${DEV_BO_API}api/invoices/pending`,
  getNextPendingInvoice: `${DEV_BO_API}api/invoices/pending/next`,
  getInvoiceById: `${DEV_BO_API}api/invoices/:id`,
  editInvoiceById: `${DEV_BO_API}api/invoices/:id`,
  deleteInvoiceById: `${DEV_BO_API}api/invoices/:id`,
  getInvoiceDistributors: `${DEV_BO_API}api/invoices/distributors`,
  getInvoiceSpendOverTime: `${DEV_BO_API}api/invoices/spend-over-time`,
  getInvoiceSpendBySupplier: `${DEV_BO_API}api/invoices/spend-by-supplier`,
  getInvoiceSpendByProduct: `${DEV_BO_API}api/invoices/spend-by-product`,
  getInvoiceSpendByCategory: `${DEV_BO_API}api/invoices/spend-by-category`,
  getInvoicePurchaseCountByCertification: `${DEV_BO_API}api/invoices/purchase-count-by-certification`,
  exportInvoicesCsvXero: `${DEV_BO_API}api/invoices/export-csv-xero`,
  exportInvoicesCsvSage: `${DEV_BO_API}api/invoices/export-csv-sage`,
  exportInvoicesCsvQuickbooks: `${DEV_BO_API}api/invoices/export-csv-quickbooks`,
  exportInvoicesCsvAgileChain: `${DEV_BO_API}api/invoices/export-csv-agilechain`,
  getInvoiceItemAttributes: `${DEV_BO_API}api/invoices/attributes`,

  // Data Mapper
  getDataMapperTemplates: `${DEV_BO_API}api/distributors/:orgId/data-mapper/templates`,
  createDataMapperTemplateFromFile: `${DEV_BO_API}api/distributors/:orgId/data-mapper/templates/from-file`,
  getDataMapperTemplateById: `${DEV_BO_API}api/distributors/:orgId/data-mapper/templates/:id`,
  updateDataMapperTemplate: `${DEV_BO_API}api/distributors/:orgId/data-mapper/templates/:id`,
  enableDataMapperTemplate: `${DEV_BO_API}api/distributors/:orgId/data-mapper/templates/:id/enable`,
  disableDataMapperTemplate: `${DEV_BO_API}api/distributors/:orgId/data-mapper/templates/:id/disable`,
  deleteDataMapperTemplate: `${DEV_BO_API}api/distributors/:orgId/data-mapper/templates/:id`,
  mapDataMapperTemplate: `${DEV_BO_API}api/distributors/:orgId/data-mapper/templates/:id/map`,
  getGenerationHistory: `${DEV_BO_API}api/prompt/generation-history`,
  getProducersByBuyerOrg: `${DEV_BO_API}api/buyers/:buyerOrgId/producers`,
  getProducersByDistributorOrg: `${DEV_BO_API}api/distributors/:distributorOrgId/producers`,
  getProductTemplatesByProducer: `${DEV_BO_API}api/prompt/producer/:producerId/products`,
  generateStory: `${DEV_BO_API}api/prompt`,
  getProductImages: `${DEV_BO_API}api/prompt/product/:productId/images`,
};
export type Endpoint = (typeof endpoints)[keyof typeof endpoints];
